// extracted by mini-css-extract-plugin
export var container = "_52-0";
export var disabled = "_52-4";
export var fullWidth = "_52-3";
export var lined = "_52-1";
export var selected = "_52-5";
export var tab = "_52-2";